<template>
  <Modal
    id="change-log-modal"
    v-model="isShow"
    :width="428"
    :maskClosable="true"
    :closable="false"
    :footer="null"
    height="auto"
    name="change-log-modal"
    dialogClass="dialog-modal"
  >
    <div class="modal-wrapper">
      <div class="title">Change Log</div>
      <div class="modal-content">
        <div>Room Detail Changes</div>
        <Collapse v-model="activeKey">
          <template #expandIcon="props">
            <Icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <CollapsePanel
            :key="room.dateUpdated"
            class="log-collapse"
            v-for="room in roomLogs"
          >
            <template #header>
              <div class="collapse-header-wrapper">
                <div>
                  {{ room.email }}
                </div>
                <div>
                  {{ moment(room.dateUpdated).format('MMMM DD, LT') }}
                </div>
              </div>
            </template>
            <div>
              <div class="fs-12">
                <table class="changes-table">
                  <tr>
                    <th>Fields</th>
                    <th>Before</th>
                    <th>After</th>
                  </tr>
                  <tr>
                    <td>Uplisting ID</td>
                    <td>{{ room.uplistingIdBefore || '-' }}</td>
                    <td>{{ room.uplistingIdAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Room Adjustment</td>
                    <td>{{ room.adjustmentBefore || '-' }}</td>
                    <td>{{ room.adjustmentAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Room Code</td>
                    <td>{{ room.codeBefore || '-' }}</td>
                    <td>{{ room.codeAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Room Description</td>
                    <td>{{ room.descriptionBefore || '-' }}</td>
                    <td>{{ room.descriptionAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Dynamic Pricing</td>
                    <td>{{ room.dynamicPricingBefore || '-' }}</td>
                    <td>{{ room.dynamicPricingAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Automatic Discount</td>
                    <td>{{ room.autoAdjustmentPercentageBefore || '-' }}</td>
                    <td>{{ room.autoAdjustmentPercentageAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Internal Name</td>
                    <td>{{ room.internalNameBefore || '-' }}</td>
                    <td>{{ room.internalNameAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Lock Type</td>
                    <td>{{ room.lockTypeBefore || '-' }}</td>
                    <td>{{ room.lockTypeAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Marketing Name</td>
                    <td>{{ room.marketingNameBefore || '-' }}</td>
                    <td>{{ room.marketingNameAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Price Max</td>
                    <td>{{ room.maxBefore || '-' }}</td>
                    <td>{{ room.maxAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Price Min</td>
                    <td>{{ room.minBefore || '-' }}</td>
                    <td>{{ room.minAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Room Image</td>
                    <td>
                      <img
                        v-if="room.roomImageBefore"
                        width="100px"
                        :src="room.roomImageBefore"
                      />
                      <div v-else>-</div>
                    </td>
                    <td>
                      <img
                        v-if="room.roomImageAfter"
                        width="100px"
                        :src="room.roomImageAfter"
                      />
                      <div v-else>-</div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </CollapsePanel>
        </Collapse>
        <div class="mt-16">Room Adjusment Changes</div>
        <Collapse v-model="activeKey">
          <template #expandIcon="props">
            <Icon type="caret-right" :rotate="props.isActive ? 90 : 0" />
          </template>
          <CollapsePanel
            :key="room.dateUpdated"
            class="log-collapse"
            v-for="room in roomAdjusmentLogs"
          >
            <template #header>
              <div class="collapse-header-wrapper">
                <div>
                  {{ room.email }}
                </div>
                <div>
                  {{ moment(room.dateUpdated).format('MMMM DD, LT') }}
                </div>
              </div>
            </template>
            <div v-if="room.logType === 'Delete'" class="fs-12">
              Delete {{ room.nameBefore }}
            </div>
            <div v-else>
              <div class="fs-12 mb-16">Event: {{ room.logType }}</div>
              <div class="fs-12">
                <table class="changes-table">
                  <tr>
                    <th>Fields</th>
                    <th>Before</th>
                    <th>After</th>
                  </tr>
                  <tr>
                    <td>Name</td>
                    <td>{{ room.nameBefore || '-' }}</td>
                    <td>{{ room.nameAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Start Adjusment</td>
                    <td>{{ room.startDateBefore || '-' }}</td>
                    <td>{{ room.startDateAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>End Adjusment</td>
                    <td>{{ room.endDateBefore || '-' }}</td>
                    <td>{{ room.endDateAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Decrease/Increase</td>
                    <td>{{ room.typeBefore || '-' }}</td>
                    <td>{{ room.typeAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Percentage/Amount</td>
                    <td>{{ room.selectBefore || '-' }}</td>
                    <td>{{ room.selectAfter || '-' }}</td>
                  </tr>
                  <tr>
                    <td>Quantity</td>
                    <td>{{ room.quantityBefore || '-' }}</td>
                    <td>{{ room.quantityAfter || '-' }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </CollapsePanel>
        </Collapse>
      </div>
      <div class="button-wrapper">
        <button @click="closeModal" class="close-btn">Close</button>
      </div>
    </div>
  </Modal>
</template>

<script>
import { Collapse, Icon } from 'ant-design-vue'
import moment from 'moment'
import calls from '@/api/calls.js'
import { Modal } from 'ant-design-vue'

const CollapsePanel = Collapse.Panel

export default {
  name: 'ChangeLogModal',
  props: {
    isShow: Boolean
  },
  components: {
    Collapse,
    Icon,
    CollapsePanel,
    Modal
  },
  data() {
    return {
      id: '',
      roomLogs: [],
      roomAdjusmentLogs: [],
      activeKey: []
    }
  },
  methods: {
    moment,
    closeModal() {
      this.activeKey = []
      this.$emit('onClose')
    },
    async getChangeLogs() {
      const roomId = this.$route.params.roomId
      const roomLogs = await calls.GET('rooms/roomLogs', roomId)
      this.roomLogs = roomLogs.result

      const roomAdjustmentLogs = await calls.GET(
        'adjustment/roomAdjustmentLogs',
        roomId
      )
      this.roomAdjusmentLogs = roomAdjustmentLogs.result
      return roomLogs.result
    }
  },
  async created() {
    await this.getChangeLogs()
  }
}
</script>

<style scoped>
.button-wrapper {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-top: 16px;
}
.modal-wrapper {
  text-align: left;
}
.title {
  font-weight: 900;
  font-size: 16px;
  color: #66b015;
  margin-bottom: 36px;
}
.close-btn {
  width: 120px;
  height: 32px;
  background: #66b015;
  border-radius: 4px;
  font-weight: 400;
  font-size: 12px;
  text-align: center;
  color: #ffffff;
  border-color: transparent;
}
.collapse-header-wrapper {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
}
.log-collapse {
  background-color: #ffffff;
}
.collapse-content-wrapper {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  column-gap: 16px;
  row-gap: 8px;
}
.collapse-content {
  font-size: 12px;
}
.changes-table {
  border-collapse: collapse;
  width: 100%;
}
.changes-table td,
th {
  border: 1px solid #dddddd;
  text-align: left;
  padding: 8px;
}
::v-deep .ant-collapse {
  border: none;
  border-radius: 0;
}
::v-deep .ant-collapse > .ant-collapse-item:last-child,
::v-deep .ant-collapse > .ant-collapse-item:last-child > .ant-collapse-header {
  border-radius: 0;
}
::v-deep .ant-collapse-content > .ant-collapse-content-box {
  padding: 16px 40px;
}
</style>
